import { useCustomQuery, useMutateData, useMutateDownload } from "shared/services/base.service";
import { COMMON_ENUM } from "shared/constants";
const BaseServicePath = "/web-api-export-invoice-creation";
const DownloadServicePath = process.env.REACT_APP_API_REPORT;

const ImportInvoiceDownloadApiService = () => ({
  useGetBrokerCd: () => {
    const data = useCustomQuery({
      url: `${BaseServicePath}/category/export-invoice/company/${COMMON_ENUM.COMPANY_CTG_CD_BROKER}/CMP_1812_000001`,
      method: "GET",
      enabled: true,
      select: data => data.result,
      keepPreviousData: true,
    });
    return data;
  },
  useGetExporterCd: () => {
    const data = useCustomQuery({
      url: `${BaseServicePath}/category/export-invoice/company/${COMMON_ENUM.COMPANY_CTG_CD_EXPORTER}/all`,
      method: "GET",
      enabled: true,
      select: data => data.result,
      keepPreviousData: true,
    });
    return data;
  },
  useImportInvoiceDownloadSearchMutation: () => {
    const { mutate } = useMutateData({
      invalidateKeys: [],
    });
    return async body => {
      return await mutate({
        url: `${BaseServicePath}/import-invoice-download/search`,
        method: "POST",
        data: body,
      });
    };
  },
  useImportInvoiceDownloadUpdateMutation: () => {
    const { mutate } = useMutateData({
      invalidateKeys: [],
    });
    return async updateData => {
      return await mutate({
        url: `${BaseServicePath}/import-invoice-download/update/${updateData.nonCommInvHId}`,
        method: "PATCH",
        data: updateData,
      });
    };
  },
  useImportInvoiceDownloadMutation: () => {
    const { mutate } = useMutateDownload({
      invalidateKeys: [],
    });
    return async body => {
      return await mutate({
        url: `${DownloadServicePath}/export-invoice-report/generatereport`,
        method: "POST",
        data: body,
      });
    };
  },
});

export const {
  useGetBrokerCd,
  useGetExporterCd,
  useImportInvoiceDownloadUpdateMutation,
  useImportInvoiceDownloadSearchMutation,
  useImportInvoiceDownloadMutation,
} = ImportInvoiceDownloadApiService();
